import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { environment } from "../../../environments/environment";
import "../../../assets/js/app_agreement.js";

declare var agreement: any;
@Component({
  selector: 'app-product-contact',
  templateUrl: './product-contact.component.html',
  styleUrls: []
})
export class ProductContactComponent implements OnInit {
  loading = false;
  id: number = 1;
  productNames =
    ["2.El Araç Tedariği Sağlama Uygulaması için",
      "2.El Araç Fiyatlandırma Uygulaması için"];
  constructor(private route: ActivatedRoute, private http: HttpClient) {

    this.id = +(this.route.snapshot.paramMap.get('id') ?? "");
    this.contactForm = new FormGroup({
      company: new FormControl('', [
        Validators.required,
      ]),
      name: new FormControl('', [
        Validators.required,
      ]),
      surName: new FormControl('', [
        Validators.required,
      ]),
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
      ]),
      phone: new FormControl('', [
        Validators.required,
      ]),
      message: new FormControl(),
      product: new FormControl(this.id)
    });
  }
  contactForm: FormGroup;
  companyValid: boolean = true;
  nameValid: boolean = true;
  surNameValid: boolean = true;
  mailValid: boolean = true;
  phoneValid: boolean = true;
  messageValid: boolean = true;
  formValid: boolean = false;
  onSubmit() {
    this.loading = true;
    if (!this.contactForm.controls['company'].valid) {
      this.companyValid = false;
    } else this.companyValid = true;

    if (!this.contactForm.controls['name'].valid) {
      this.nameValid = false;
    } else this.nameValid = true;

    if (!this.contactForm.controls['surName'].valid) {
      this.surNameValid = false;
    } else this.surNameValid = true;

    if (!this.contactForm.controls['email'].valid) {
      this.mailValid = false;
    } else this.mailValid = true;

    if (!this.contactForm.controls['phone'].valid) {
      this.phoneValid = false;
    } else this.phoneValid = true;

    if (!this.contactForm.controls['message'].valid) {
      this.messageValid = false;
    } else this.messageValid = true;

    if (this.companyValid && this.nameValid && this.surNameValid && this.mailValid && this.phoneValid)
      this.saveInfo();
    else this.loading = false;
  }
  checkPhone() {
    if (this.contactForm.controls["phone"].value[0] == '0')
      this.contactForm.controls["phone"].setValue(this.contactForm.controls["phone"].value.substr(1));
  }
  ngOnInit() {
    agreement.init();
  }
  saveInfo() {
    let url = environment.notificationUrl + "/v1/notifications/email"
    let raw = this.contactForm.getRawValue();
    let req = {
      subject: "Ürün Demo Talebi Formu",
      params: {
        "Talep Edilen Ürün": this.productNames[raw.product - 1] || "Bilinmeyen Ürün",
        "Şirket Adı": raw.company,
        "Ad": raw.name,
        "Soyad": raw.surName,
        "E-Posta": raw.email,
        "Telefon": raw.phone,
        "Mesaj": raw.message
      }
    };
    this.http
      .post(url, req)
      .subscribe(
        responseData => {
          this.loading = false;
          this.formValid = true;
        },
        error => {
          this.loading = false;
          this.formValid = true;
        }
      );
  }
}
